// extracted by mini-css-extract-plugin
module.exports = {"desktop-renderer":"_2Qgloid5BBfVz1Riqq1OKp","mobile-renderer":"_1bgRe-_3FdIdKoL3T1uWqM"};